module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleA.6e16046e.png";